/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Pilot_How_Practice_DescInputs */



/**
* | output |
* | --- |
* | "A new practice conversation of about ten minutes every week, spoken or typed. You can repeat it as often as you like." |
*
* @param {Onboarding_Pilot_How_Practice_DescInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_pilot_how_practice_desc = /** @type {((inputs?: Onboarding_Pilot_How_Practice_DescInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Pilot_How_Practice_DescInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Elke week een nieuw oefengesprek van zo’n tien minuten, gesproken of getypt. Je mag zo vaak herhalen als je wil.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chaque semaine, un nouvel entretien d’entraînement d’une dizaine de minutes, à l’oral ou à l’écrit. Vous pouvez le refaire aussi souvent que vous le souhaitez.")
	return /** @type {LocalizedString} */ ("A new practice conversation of about ten minutes every week, spoken or typed. You can repeat it as often as you like.")
});